import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-helpbutton-new-department',
  templateUrl: './helpbutton-new-department.component.html',
  styleUrls: ['./helpbutton-new-department.component.scss']
})
export class HelpbuttonNewDepartmentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
